module.exports = __webpack_public_path__ + "media/images/user/favicons/site-tile-310x310-560e29428d245802ec4c11a4779558b7.png";